export default (curUserObj={}, action) => {
    switch (action.type) {
        case 'FETCH_APPROVALS':
            //console.log(`Cur User name ${action.payload.name}`);
            return action.payload.curUserInfo;
         default:
             return curUserObj;
    }
 };